import { Button, Card, device, Grey_, Grey_Link, IconSvg, Main_Plain, Sub_Status } from 'monica-alexandria'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { GriphookSvg } from '../../svg/GriphookSvg'

const SubscriptionHistoryBlock = styled(Card)`
  padding: 1rem;
  margin-bottom: 1rem;
  overflow: visible !important;
  p{
    font-size: 1.2rem;
  }

  h6{
    font-size: 1.2rem;
    color: var(--greyDark);
    text-align: right;
  }
`

const SubscriptionHistoryBlockPrice = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`


const SubscriptionCardEditWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
const SubscriptionCardEdit = styled.div`
  display: flex;

  box-shadow: ${p => p.theme.out};
  border-radius: var(--normalRadius);
  position: relative;
  width: fit-content;

  
  @media ${device.md} {
    width: 100%;
  }
`

const SubscriptionCardEditLeft = styled(Button)`
  background: ${p => p.theme.mid};
  border-top-left-radius: var(--normalRadius);
  border-bottom-left-radius: var(--normalRadius);
  border: 2px solid ${p => p.theme.mid};
  
  @media ${device.md} {
    width: 100%;
  }

  span{
    color: ${p => p.theme.color};
  }

  svg{
    fill: ${p => p.theme.color};
  }
`

const SubscriptionCardEditRevoke = styled(SubscriptionCardEditLeft)`
  svg{
    fill: var(--success);
  }

  span{
    color: var(--success);
  }
`

const SubscriptionCardEditRight = styled(Button)`
  border-top-right-radius: var(--normalRadius);
  border-bottom-right-radius: var(--normalRadius);
   background: ${p => p.theme.background};
   border: 2px solid ${p => p.theme.mid};

  svg{
    fill: ${p => p.theme.color};
  }
`

const SubscriptionCardBullets = styled.div`
  position: absolute;
  right: 0;
  bottom: 5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

`

const SubscriptionCardBulletsItem = styled(Button)`
  border-radius: var(--normalRadius);
  /* overflow: hidden; */
  margin-top: .5rem;
  background: ${p => p.theme.color};

  span{
    color: ${p => p.theme.background};
  }

  svg{
    fill: ${p => p.theme.background};
  }
`


const SubscriptionCardBulletsRevoke = styled(SubscriptionCardBulletsItem)`
  svg{
    fill: var(--success);
  }

  span{
    color: var(--success);
  }
`


export default function Subscription_History_Block(props) {
  
  const {t} = useTranslation()

  const [bullets, setBullets] = useState(false);
  const BulletsRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (BulletsRef.current && !BulletsRef.current.contains(e.target)) {
        setBullets(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <SubscriptionHistoryBlock>
      <h6>{props.status}</h6>
      <SubscriptionHistoryBlockPrice>
        <h2>{props.currency}</h2>
        <h2>{props.price}</h2>
      </SubscriptionHistoryBlockPrice>
      <p>{props.date}</p>
      {/* <DailyprofitSvg  */}

      {/* {props.metaInvoice || props.wrappInvoice ?
        <SubscriptionCardEditWrapper>
           <SubscriptionCardEdit>
          
                <SubscriptionCardEditLeft onClick={""}>
                  <IconSvg Icon="Payment" />
                  <span>{t("Invoices")}</span>
                </SubscriptionCardEditLeft>
             
                <SubscriptionCardEditRight ref={BulletsRef} onClick={() => setBullets(!bullets)}>
                  <IconSvg Icon="More" />
                </SubscriptionCardEditRight>
              {bullets ?
                <SubscriptionCardBullets ref={BulletsRef}>
                   { props.metaInvoice ?
                  <SubscriptionCardBulletsItem onClick={props.onMetaInvoiceClick}>
                    <GriphookSvg Icon="Meta" />
                    <span>{t("Meta invoice")}</span>
                  </SubscriptionCardBulletsItem>
                : null}
                 { props.wrappInvoice ?
                    <SubscriptionCardBulletsItem onClick={props.onWrappInvoiceClick}>
                      <IconSvg Icon="Wrapp" />
                      <span>{t("Wrapp invoice")}</span>
                    </SubscriptionCardBulletsItem>
                  : null}
                 
                </SubscriptionCardBullets>
              :
                null  
              }
            </SubscriptionCardEdit>
            </SubscriptionCardEditWrapper>
          : null} */}

        <SubscriptionCardEditWrapper>
          {props.invoice ? 
            <Grey_ size='small' noPadding text={t("Invoice")} iconLeft="File" onClick={props.onInvoice}/>
          : null}
          </SubscriptionCardEditWrapper>
      {/* Dates are not translated */}
      {/* <Grey_Link noPadding text={t("Get invoice")} iconLeft="File" onClick={() => window.location.href = props.invoicePdf}/> */}
    </SubscriptionHistoryBlock>
  )
}
